// @ts-ignore
import Api from '@/util/api'
// @ts-ignore
import Apis from '@/util/apis'
import GridReadApis from '@/util/gridrapis'
// @ts-ignore
import util from '@/util/util'
import { Exchange, StatsData } from '@/util/types'
// @ts-ignore
import $store from '@/store/index'
// @ts-ignore
import Data from '@/util/data'
import Decimal from 'decimal.js'

export default {
  get statsdata () {
    return $store.state.stats as StatsData
  },
  combinePNLByDay (basePNL: any, gridPNL: any) {
    if (!basePNL?.Values) return gridPNL || {}
    if (!gridPNL?.Values) return basePNL

    return {
      Labels: basePNL.Labels,
      Values: basePNL.Values.map((baseValue: string, index: number) => {
        const gridValue = gridPNL.Values[index] || '0'
        return new Decimal(baseValue).plus(new Decimal(gridValue)).toString()
      })
    }
  },
  calculateTotalPNLByDay (pnlData: any) {
    if (!pnlData?.Values || !pnlData?.Labels) return {}

    let runningTotal = new Decimal(0)
    const cumulativeValues = pnlData.Values.map((value: string) => {
      runningTotal = runningTotal.plus(new Decimal(value))
      return runningTotal.toString()
    })

    return {
      Labels: pnlData.Labels,
      Values: cumulativeValues
    }
  },
  combineTotal (baseTotal: any, gridTotal: any) {
    if (!baseTotal) return gridTotal || { Orders: 0, Volume: '0', PNL: '0' }
    if (!gridTotal) return baseTotal

    return {
      Orders: (baseTotal.Orders || 0) + (gridTotal.Orders || 0),
      Volume: new Decimal(baseTotal.Volume || '0').plus(new Decimal(gridTotal.Volume || '0')).toString(),
      PNL: new Decimal(baseTotal.PNL || '0').plus(new Decimal(gridTotal.PNL || '0')).toString()
    }
  },
  async updateStats () {
    if (!$store.state.sys.tradeExchange.ExchId) {
      return
    }
    // Set loading states
    $store.state.statsdata.LoadingTrades = true
    $store.state.statsdata.LoadingBots = true
    $store.state.statsdata.LoadingBoosters = true

    try {
      // Get base stats data
      const baseStatsData = await this.updateStatsOld()

      // Get grid stats if applicable
      let gridStatsData: any = null
      if ($store.state.statsdata.BotStat && ($store.state.sys.tradeExchange.ExchId === 'BYF' || $store.state.sys.tradeExchange.ExchId === 'GEF')) {
        gridStatsData = await this.updateGridStats()
      }

      // Combine data and update store
      if (baseStatsData) {
        let combinedStats = baseStatsData

        // Override with grid stats if available
        if (gridStatsData) {
          const combinedPNLByDay = this.combinePNLByDay(baseStatsData.PNLByDay, gridStatsData.PNLByDay)
          const combinedTotal = this.combineTotal(baseStatsData.Total, gridStatsData.Total)
          combinedStats = {
            ...baseStatsData,
            Bots: gridStatsData.Total || baseStatsData.Bots,
            Total: combinedTotal,
            PNLByDay: combinedPNLByDay,
            TotalPNLByDay: this.calculateTotalPNLByDay(combinedPNLByDay)
          }
        }

        $store.state.stats = combinedStats
      } else {
        this.clearStats()
      }
    } catch (error) {
      console.log('updateStats error:', error)
      this.clearStats()
    } finally {
      // Clear loading states
      $store.state.statsdata.LoadingTrades = false
      $store.state.statsdata.LoadingBots = false
      $store.state.statsdata.LoadingBoosters = false
    }
  },
  async updateGridStats () {
    const params = {
      // @ts-ignore
      etid: $store.state.sys.tradeExchange.Id
    }
    if ($store.state.statsdata.Dates && $store.state.statsdata.Dates.length === 2 && $store.state.statsdata.Dates[0] !== '') {
      // @ts-ignore
      params.tz = $store.state.statsdata.Dates[0].getTimezoneOffset() / -60

      // @ts-ignore
      params.dates = ($store.state.statsdata.Dates[0].getTime() / 1000).toFixed(0) + ',' + (($store.state.statsdata.Dates[1].getTime() / 1000) + 24 * 3600).toFixed(0)
    } else {
      const d = new Date()
      d.setHours(0, 0, 0, 0)
      // @ts-ignore
      params.tz = d.getTimezoneOffset() / -60
      // @ts-ignore
      const dates = [new Date(d - 2505600000), d]
      // @ts-ignore
      params.dates = (dates[0].getTime() / 1000).toFixed(0) + ',' + ((dates[1].getTime() / 1000) + 24 * 3600).toFixed(0)
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    try {
      const response = await GridReadApis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('stats', { params, headers })
      console.log('updateGridStats:', JSON.stringify(response.data))
      if (response.data !== null) {
        if (!response.data.err) {
          return response.data
        } else {
          console.log(response.data.err)
          return null
        }
      } else {
        return null
      }
    } catch (err) {
      console.log('updateStats err:', err)
      return null
    }
  },
  async updateStatsOld () {
    const params = {
      params: {
        // @ts-ignore
        token: $store.state.sys.token,
        // @ts-ignore
        etid: $store.state.sys.tradeExchange.Id,
        td: $store.state.statsdata.TradeStat ? '1' : '0',
        bt: $store.state.statsdata.BotStat && $store.state.sys.tradeExchange.ExchId !== 'BIF' ? '1' : '0',
        br: $store.state.statsdata.BoosterStat && $store.state.sys.tradeExchange.ExchId === 'BIF' ? '1' : '0'
      }
    }
    if (params.params.td === '0' && params.params.bt === '0' && params.params.br === '0') {
      return null
    }
    if ($store.state.statsdata.Dates && $store.state.statsdata.Dates.length === 2 && $store.state.statsdata.Dates[0] !== '') {
      // @ts-ignore
      params.params.dates = (($store.state.statsdata.Dates[0].getTime() - $store.state.statsdata.Dates[0].getTimezoneOffset() * 60000) / 1000).toFixed(0) + ',' + ((($store.state.statsdata.Dates[1].getTime() - $store.state.statsdata.Dates[1].getTimezoneOffset() * 60000) / 1000) + 24 * 3600).toFixed(0)
    } else {
      const d = new Date()
      d.setHours(0, 0, 0, 0)
      // @ts-ignore
      const dates = [new Date(d - 2505600000), d]
      // @ts-ignore
      params.params.dates = ((dates[0].getTime() - dates[0].getTimezoneOffset() * 60000) / 1000).toFixed(0) + ',' + (((dates[1].getTime() - dates[1].getTimezoneOffset() * 60000) / 1000) + 24 * 3600).toFixed(0)
    }
    // console.log('updateStats', params)
    // console.log('stats before:', this.statsdata)
    try {
      const response = await Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('asset/stats', params)
      // console.log('updateStats:', JSON.stringify(response.data))
      if (response.data !== null) {
        if (!response.data.err) {
          return response.data
        } else {
          console.log(response.data.err)
          return null
        }
      } else {
        return null
      }
    } catch (err) {
      console.log('updateStats err:', err)
      return null
    }
  },
  profitDollarSign (value: string) {
    if (parseFloat(value) < 0) {
      const profit = new Decimal(value).neg().toString()
      return '-$' + profit
    }
    return '$' + value
  },
  clearStats () {
    $store.state.stats = {
      PNLByDay: {},
      TotalPNLByDay: {},
      Trades: { Pos: 0, Neg: 0, Orders: 0, Volume: 0, PNL: 0 },
      Bots: { Pos: 0, Neg: 0, Orders: 0, Volume: 0, PNL: 0 },
      Boosters: { Pos: 0, Neg: 0, Orders: 0, Volume: 0, PNL: 0 },
      Total: { Orders: 0, Volume: 0, PNL: 0 }
    }
  },
  downloadReport () {
    const params = {
      params: {
        // @ts-ignore
        token: $store.state.sys.token,
        // @ts-ignore
        etid: $store.state.sys.tradeExchange.Id,
        td: $store.state.statsdata.TradeStat ? '1' : '0',
        bt: $store.state.statsdata.BotStat && $store.state.sys.tradeExchange.ExchId !== 'BIF' ? '1' : '0',
        br: $store.state.statsdata.BoosterStat && $store.state.sys.tradeExchange.ExchId === 'BIF' ? '1' : '0'
      }
    }
    if (params.params.td === '0' && params.params.bt === '0' && params.params.br === '0') {
      return
    }
    const d = new Date()
    d.setHours(0, 0, 0, 0)
    // @ts-ignore
    let dates = [new Date(d - 2505600000), d]
    if ($store.state.statsdata.Dates && $store.state.statsdata.Dates.length === 2 && $store.state.statsdata.Dates[0] !== '') {
      // console.log($store.state.statsdata.Dates)
      dates = $store.state.statsdata.Dates
      // @ts-ignore
      params.params.dates = (($store.state.statsdata.Dates[0].getTime() - $store.state.statsdata.Dates[0].getTimezoneOffset() * 60000) / 1000).toFixed(0) + ',' + ((($store.state.statsdata.Dates[1].getTime() - $store.state.statsdata.Dates[1].getTimezoneOffset() * 60000) / 1000) + 24 * 3600).toFixed(0)
    } else {
      // var d = new Date()
      // d.setHours(0, 0, 0, 0)
      // // @ts-ignore
      // var dates = [new Date(d - 518400000), d]
      // @ts-ignore
      params.params.dates = ((dates[0].getTime() - dates[0].getTimezoneOffset() * 60000) / 1000).toFixed(0) + ',' + (((dates[1].getTime() - dates[1].getTimezoneOffset() * 60000) / 1000) + 24 * 3600).toFixed(0)
    }
    // console.log('download report', params)
    Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('asset/stats_report', params)
      .then((response: any) => {
        // console.log('download report:', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')

            fileLink.href = fileURL
            const exchange = $store.state.sys.exchanges.find((exch: Exchange) => {
              return exch.Id === $store.state.sys.tradeExchange.Id
            })
            let exchId = exchange.ExchId
            switch (exchId) {
              case 'BIN':
                exchId = 'BINANCE'
                break
              case 'BIF':
                exchId = 'BINANCE_FUTURES'
                break
              case 'BIM':
                exchId = 'BINANCE_MARGIN'
                break
              case 'EXM':
                exchId = 'EXMO'
                break
              case 'FTX':
                break
              case 'HUO':
                exchId = 'HUOBI'
                break
            }
            const filename = exchId + '_' + exchange.Name.replace(/ /g, '_') + '_' + dates[0].toISOString().split('T')[0] + '_' + dates[1].toISOString().split('T')[0]
            fileLink.setAttribute('download', filename + '.csv')
            document.body.appendChild(fileLink)

            fileLink.click()
          } else {
            console.log(response.data.err)
            Data.vm.$Notice.info({
              title: Data.vm.$text.tr('нет данных'),
              duration: 1
            })
          }
        } else {
        }
      }).catch((error: any) => {
        // error
        console.log('download report err:', error)
      })
  }
}
